import { styled } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import TuneIcon from "@mui/icons-material/Tune";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import { useEffect, useState } from "preact/hooks";
import { route } from "preact-router";
import LogoutIcon from "@mui/icons-material/Logout";
import Logo from "../../assets/logo.png";
import {
  clearLocalStorage,
  getLocalStorage,
  removeCookie,
  clearCookies,
} from "../../utils";
import { logoutApi } from "../../api/controller/accounts";
import useApi from "../../hooks/useApi";
import {
  AdUnits,
  CheckBox,
  Fastfood,
  LocalOffer,
  Verified,
  Campaign,
  SupervisedUserCircle,
  Wallet,
} from "@mui/icons-material";
import { Link } from "preact-router/match";
import CelebrationIcon from "@mui/icons-material/Celebration";
import BusinessIcon from "@mui/icons-material/Business";
import ScannerIcon from "@mui/icons-material/Scanner";
const NavbarContainer = styled("nav")`
  width: 180px;
  background-color: #1c1c1e;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 25px 0;
  font-weight: 600;
  @media only screen and (max-width: 724px) {
    display: none;
  }
  .topNavbarContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .logo {
    width: 160px;
    height: auto;
  }
  .userRoutes {
    text-align: center;
    margin-top: 2.778vh;
    max-height: calc(100vh - 150px);
    overflow-y: auto;

    padding-left: 20px;
  }
  .userStateRoutes {
  }
  .navbarContainer {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 2.778vh;
  }
  .routeLink {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 2.778vh;
    text-decoration: none;

    .navbarIcon {
      height: 21px;
      width: 21px;
      color: #c4c4c4;
    }
    .navbarRoute {
      color: #c4c4c4;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      margin-left: 10px;
    }
  }
  .activeRouteLink {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 2.778vh;
    text-decoration: none;

    .navbarIcon {
      height: 21px;
      width: 21px;
      color: #fff;
    }
    .navbarRoute {
      margin-left: 10px;
      color: #ffffff;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }
  }
`;
const ExploreButton = styled("button")`
  position: relative;
  background: #1a1a1a;
  color: white;
  border: 1px solid transparent;
  border-radius: 25px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(103, 65, 217, 0.3);
  transform: translateY(0px);

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: conic-gradient(
      from 0deg,
      transparent 70deg,
      rgb(103, 65, 217) 120deg,
      #ff6b9d 180deg,
      rgb(103, 65, 217) 240deg,
      transparent 290deg
    );
    animation: rotate 3s linear infinite !important;
    animation-play-state: running !important;
    z-index: -1;
  }

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    background: #1a1a1a;
    border-radius: 25px;
    z-index: -1;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &:active {
    transform: translateY(0);
  }
`;
function Navbar({ pendingSongRequestsList = { pendingSongRequestsList } }) {
  const logoutRequest = useApi();
  const [isThirdPartyBrand, setIsThirdPartyBrand] = useState(
    getLocalStorage("business_type") === "brand"
  );

  useEffect(() => {
    // Check localStorage periodically for business_type updates
    const checkInterval = setInterval(() => {
      const flag = getLocalStorage("business_type");
      setIsThirdPartyBrand(flag === "brand");
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    if (
      logoutRequest.data &&
      logoutRequest.data.data &&
      logoutRequest.data.data.logout
    ) {
      route("/");
      clearLocalStorage();
      clearCookies();
    }
    if (logoutRequest.errorBody?.response?.data?.response === "Failed") {
      clearLocalStorage();
      clearCookies();
      route("/");
    }
  }, [logoutRequest.data, logoutRequest.errorBody]);

  const userLogout = () => {
    logoutApi(logoutRequest.request, {
      host: getLocalStorage("host"),
    });
  };

  return (
    <NavbarContainer pendingSongRequestsList={pendingSongRequestsList}>
      <div className="topNavbarContainer">
        <img src={Logo} alt="Dhun Jam" className="logo" />
        <div
          className="userRoutes"
          style={{
            paddingLeft: "0",
            paddingRight: "5px",
          }}
        >
          {!isThirdPartyBrand && (
            <>
              <Link
                activeClassName="activeRouteLink"
                class="routeLink"
                href="/home"
              >
                <HomeIcon className={"navbarIcon"} />
                <div className={"navbarRoute"}>Home</div>
              </Link>
              <Link
                activeClassName="activeRouteLink"
                class="routeLink"
                href="/setting"
              >
                <TuneIcon className={"navbarIcon"} />
                <div className={"navbarRoute"}>Settings</div>
              </Link>
              <Link
                activeClassName="activeRouteLink"
                class="routeLink"
                href="/analytics"
              >
                <EqualizerIcon className={"navbarIcon"} />
                <div className={"navbarRoute"}>Analytics</div>
              </Link>
              <Link
                activeClassName="activeRouteLink"
                class="routeLink"
                href="/played-songs"
              >
                <CheckBox className={"navbarIcon"} />
                <div className={"navbarRoute"}>Played</div>
              </Link>
            </>
          )}

          <Link
            activeClassName="activeRouteLink"
            class="routeLink"
            href="/admin-offer"
          >
            <LocalOffer className={"navbarIcon"} />
            <div className={"navbarRoute"}>Offers</div>
          </Link>
          {!isThirdPartyBrand && (
            <Link
              activeClassName="activeRouteLink"
              class="routeLink"
              href="/claim-offer"
            >
              <Verified className={"navbarIcon"} />
              <div className={"navbarRoute"}>Claims</div>
            </Link>
          )}
          <Link
            activeClassName="activeRouteLink"
            class="routeLink"
            href="/event-offer"
          >
            <CelebrationIcon className={"navbarIcon"} />
            <div className={"navbarRoute"}>Events</div>
          </Link>

          <Link
            activeClassName="activeRouteLink"
            class="routeLink"
            href="/must-try"
          >
            <Fastfood className={"navbarIcon"} />
            <div className={"navbarRoute"}>Must Try</div>
          </Link>

          {/* <Link
            activeClassName="activeRouteLink"
            class="routeLink"
            href="/services"
          >
            <AdUnits className={"navbarIcon"} />
            <div className={"navbarRoute"}>Advertisement</div>
          </Link> */}

          <Link
            activeClassName="activeRouteLink"
            class="routeLink"
            href="/promote"
          >
            <Campaign className={"navbarIcon"} />
            <ExploreButton className={"navbarRoute"}>Promote</ExploreButton>
          </Link>
          {!isThirdPartyBrand && (
            <>
              <Link
                activeClassName="activeRouteLink"
                class="routeLink"
                href="/check-in"
              >
                <SupervisedUserCircle className={"navbarIcon"} />
                <div className={"navbarRoute"}>Check-in</div>
              </Link>
              <Link
                activeClassName="activeRouteLink"
                class="routeLink"
                href="/subscription"
              >
                <Wallet className={"navbarIcon"} />
                <div className={"navbarRoute"}>Subscription</div>
              </Link>
            </>
          )}
        </div>
      </div>

      <div
        className="routeLink"
        onClick={() => {
          userLogout();
        }}
      >
        <LogoutIcon className={"navbarIcon"} />
        <div className={"navbarRoute"}>Logout</div>
      </div>
    </NavbarContainer>
  );
}

export default Navbar;
